import { Text } from '@naf/text';
import { spacing } from '@naf/theme';
import styled from '@emotion/styled';
import RelatedArticleList from '@components/related-articles/RelatedArticleList';

export const StyledText = styled(Text)``;

export const StyledRelatedArticleList = styled(RelatedArticleList)`
  & .card {
    margin-bottom: 0 !important;
    padding-top: ${spacing.space32};
  }
`;
